var render, staticRenderFns
import script from "./vButton.vue?vue&type=script&lang=js"
export * from "./vButton.vue?vue&type=script&lang=js"
import style0 from "./vButton.vue?vue&type=style&index=0&id=34fc35b6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports